var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavigationAppbar'),_c('v-main',{staticStyle:{"padding":"0 !important"}},[_c('router-view')],1),_c('v-footer',{attrs:{"app":""}},[_c('LayoutFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }